import React from 'react';

import tobeor from 'tobeor';

import Loader from '../../Loader';

import ClearIcon from '@mui/icons-material/Clear';
import CheckIcon from '@mui/icons-material/Check';

export default ({
  rst,
  type,
  trpl,
  classes,
  groupId,
  setTrpl,
  constant,
  isVirtual,
  trplIndex,
  ancestorId,
  loadingTids,
  setLoadingTids,
  removeTrplValue,
  setDeletedTrplId,
  autocompleteTrpls,
  resetAutocompleteTrpls,
}) => {
  const isTimeRst = tobeor(rst.type, ['DATE', 'TIME', 'DATE_AND_TIME']);
  const isInteger = tobeor(rst.type, ['INTEGER', 'FLOAT']);
  const isFile = tobeor(rst.type, ['render_parts', 'FILE', 'IMAGE', 'GEOLOCATION', 'TELEGRAM_LOCATION'])
  const hideActionBtns = tobeor(type, ['BUTTON', 'OBJECT']) || isVirtual || constant;
  const restorableRst =  tobeor(rst.type, ['STRING', 'TEXTAREA', 'GEOLOCATION', 'INTEGER', 'FLOAT', 'URL', 'PRICE', 'PHONE', 'EMAIL', 'FACEBOOK_MID', 'TELEGRAM_ID']);

  const value = isTimeRst && (!trpl || trpl.val === '') ? new Date().getTime() : trpl.val;

  const rstDefaultUnitDafault = rst.units && rst.units.find(unit => unit.hasOwnProperty('default'));
  const defaultUnitId = rstDefaultUnitDafault ? rstDefaultUnitDafault.id : '';
  const rstTomezoneDefault = rst.timezones && rst.timezones.find(zone => zone.hasOwnProperty('default'));
  const defaultTimezoneId = rstTomezoneDefault ? rstTomezoneDefault.id : '';
  const addition = isTimeRst ? (trpl && trpl.hasOwnProperty('tz') ? {tz: trpl.tz} : defaultTimezoneId ? {tz: defaultTimezoneId} : null)
    : isInteger ? (trpl && trpl.hasOwnProperty('units') ? {units: trpl.units} : defaultUnitId ? {units: defaultUnitId} : null) : null;

  const rstId = Array.isArray(rst.id) ? rst.id[rst.id.length - 1] : rst.id;

  return (
    <div
      className={`${classes.setDeleteTrplBtnsContainer}`}
      style={{ width: isFile || (rst.type === 'URL' && trpl.tid) ? 'fit-content' : '50px' }}>
      {loadingTids.includes(trpl.tid) ? (
        <Loader style={{ zoom: '0.7', marginLeft: '5px' }} />
      ) : !hideActionBtns ? (
        <div className={classes.alignCenter}>
          {isFile || (rst.type === 'URL' && trpl.tid) ? null : (
            <div style={{ display: 'flex', width: '24px', marginRight: '5px' }}>
                <CheckIcon
                  onClick={() => {
                    setTrpl(ancestorId, rst, value, rst.type === 'BOOLEAN', trpl && trpl.tid ? trpl.tid : undefined, setLoadingTids, addition);

                    if (autocompleteTrpls && autocompleteTrpls.length) resetAutocompleteTrpls();
                  }}
                  className={`${classes.rstIconBtn} ${classes.rstIconBtnGreen}`}
                />
            </div>
          )}

          {trpl.tid ? (
            <ClearIcon
              color="secondary"
              className={`${classes.rstIconBtn} ${classes.rstIconBtnRed}`}
              onClick={() => {
                const callbacks = {
                  setLoadingTids,
                  setDeletedTrplId: isTimeRst || restorableRst ? setDeletedTrplId : null,
                };

                removeTrplValue(trpl.tid, rstId, trplIndex, ancestorId, groupId, rst, callbacks);

                if (autocompleteTrpls && autocompleteTrpls.length) resetAutocompleteTrpls();
              }}
            />
          ) : null}
        </div>
      ) : null }
    </div>
  );
};
